<template>
  <div>
      <el-drawer
        ref="drawer"
        :title="title"
        destroy-on-close
        :visible.sync="drawer"
        direction="rtl"
        :append-to-body="true"
        :before-close="handleClose"
        :width="drawerWidth"
      >
        <component :is="activeForm" v-model="form" :extendAttrConfig="extendAttrConfig">
          <template v-slot:[key]="data" v-for="(item, key) in $scopedSlots">
            <slot :name="key" v-bind="data || {}"></slot>
          </template>
        </component>
        </el-drawer>
  </div>
</template>

<script>
import SnakerStart from './start'
import SnakerEnd from './end'
import SnakerDecision from './decision'
import SnakerTask from './task'
import SnakerTransition from './transition'
import SnakerProcess from './process'


export default {
  components: {
    SnakerStart,
    SnakerEnd,
    SnakerDecision,
    SnakerTask,
    SnakerTransition,
    SnakerProcess,
  },
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    node: {
      type: Object,
      default () {
        return {}
      }
    },
    lf: {
      type: Object,
      default () {
        return null
      }
    },
    extendAttrConfig: { // 扩展属性配置
      type: Object
    },
  },
  data () {
    return {
      drawer: false,
      form: {},
      nodeId: undefined,
      activeForm: undefined,
      extendPropertyKeys: [
        'EMPNM',
        'FRDTTM',
        'FINDTTM',
        'WKTY',
        'ITEMTY',
        'SRC',
        'OUTPUT',
        'REFIDTY',
        'REFIDNO',
        'RMK',
        'EMPIDSEQ'
      ]
    }
  },
  computed: {
    title () {
      if (this.node && this.node.type === 'snaker:transition') {
        return '设置边属性'
      } else if (this.node && this.node.type === 'snaker:process') {
        return '设置流程属性'
      }
      return '设置节点属性'
    },
    drawerWidth () {
      const min = 500
      const maxPercent = 0.50

      const winWidth = document.documentElement.clientWidth || window.innerWidth
      const calc = Math.floor(winWidth * maxPercent)

      return calc < min ? `${min}px` : `${calc}px`
    }
  },
  watch: {
    node (n) {
      if (!n) return

      if (n.type === 'snaker:process') {
        this.form = n
        return
      }

      this.nodeId = n.id
      const props = n.properties || {}

      this.form = {
        name: n.id,
        displayName: n.text instanceof Object ? n.text.value : n.text,
        actionBtns: [],

        // 原属性
        ...props,

        // ✅ 关键：责任人单值化兜底
        EMPNM: Array.isArray(props.EMPNM)
            ? props.EMPNM[0] || ''
            : props.EMPNM || ''
      }
    },
    'form.name' (n, o) {
      // 监听名称变量并更新
      if (this.node.type === 'snaker:process') {
        this.$emit('input', {
          ...this.value,
          name: n
        })
      } else {
        if (n && o) {
          if (['snaker:transition'].includes(this.node.type)) {
            if (!this.lf.getEdgeModelById(n)) {
              this.lf.changeEdgeId(o, n)
            }
          } else if (['snaker:decision'].includes(this.node.type)) {
            if (!this.lf.getNodeModelById(n)) {
              this.lf.changeNodeId(o, n)
            }
          } else {
            if (!this.lf.getNodeModelById(n)) {
              this.lf.changeNodeId(o, n)
            }
          }
          this.nodeId = n
        }
      }
    },
    'form.displayName' (n) {
      // 监听显示名称变化并更新
      if (this.node.type === 'snaker:process') {
        this.$emit('input', {
          ...this.value,
          displayName: n
        })
      } else {
        this.lf.updateText(this.nodeId, n)
      }
    },
    'form.form' (n) {
      // 监听表单属性变化并更新
      this.lf.setProperties(this.nodeId, {
        form: n
      })
    },
    'form.assignee' (n) {
      // 监听参与者属性变化并更新
      this.lf.setProperties(this.nodeId, {
        assignee: n
      })
    },
    'form.assignmentHandler' (n) {
      // 监听参与者处理类属性变化并更新
      this.lf.setProperties(this.nodeId, {
        assignmentHandler: n
      })
    },
    'form.taskType' (n) {
      // 监听任务类型属性变化并更新
      this.lf.setProperties(this.nodeId, {
        taskType: n
      })
    },
    'form.performType' (n) {
      // 监听参与类型属性变化并更新
      this.lf.setProperties(this.nodeId, {
        performType: n
      })
    },
    'form.preInterceptors' (n) {
      // 监听前置拦截器属性变化并更新
      if (this.node.type === 'snaker:process') {
        this.$emit('input', {
          ...this.value,
          preInterceptors: n
        })
      } else {
        this.lf.setProperties(this.nodeId, {
          preInterceptors: n
        })
      }
    },
    'form.postInterceptors' (n) {
      // 监听后置拦截器属性变化并更新
      if (this.node.type === 'snaker:process') {
        this.$emit('input', {
          ...this.value,
          postInterceptors: n
        })
      } else {
        this.lf.setProperties(this.nodeId, {
          postInterceptors: n
        })
      }
    },
    'form.reminderTime' (n) {
      // 监听提醒时间属性变化并更新
      this.lf.setProperties(this.nodeId, {
        reminderTime: n
      })
    },
    'form.reminderRepeat' (n) {
      // 监听重复提醒间隔属性变化并更新
      this.lf.setProperties(this.nodeId, {
        reminderRepeat: n
      })
    },
    'form.expireTime' (n) {
      // 监听期待完成时间属性变化并更新
      if (this.node.type === 'snaker:process') {
        this.$emit('input', {
          ...this.value,
          expireTime: n
        })
      } else {
        this.lf.setProperties(this.nodeId, {
          expireTime: n
        })
      }
    },
    'form.autoExecute' (n) {
      // 监听是否自动完成属性变化并更新
      this.lf.setProperties(this.nodeId, {
        autoExecute: n
      })
    },
    'form.callback' (n) {
      // 监听回调处理属性变化并更新
      this.lf.setProperties(this.nodeId, {
        callback: n
      })
    },
    'form.expr' (n) {
      // 监听决策表达式属性变化并更新
      this.lf.setProperties(this.nodeId, {
        expr: n
      })
    },
    'form.handleClass' (n) {
      // 监听处理类属性变化并更新
      this.lf.setProperties(this.nodeId, {
        handleClass: n
      })
    },
    'form.clazz' (n) {
      // 监听类路径属性变化并更新
      this.lf.setProperties(this.nodeId, {
        clazz: n
      })
    },
    'form.methodName' (n) {
      // 监听方法名属性变化并更新
      this.lf.setProperties(this.nodeId, {
        methodName: n
      })
    },
    'form.args' (n) {
      // 监听参数变量属性变化并更新
      this.lf.setProperties(this.nodeId, {
        args: n
      })
    },
    'form.instanceUrl' (n) {
      // 监听流程实例启动Url变量属性变化并更新
      if (this.node.type === 'snaker:subProcess') {
        this.lf.setProperties(this.nodeId, {
          instanceUrl: n
        })
      } else {
        this.$emit('input', {
          ...this.value,
          instanceUrl: n
        })
      }
    },
    'form.instanceNoClass' (n) {
      // 监听流程实例编号生成类变量属性变化并更新
      if (this.node.type === 'snaker:subProcess') {
        this.lf.setProperties(this.nodeId, {
          instanceNoClass: n
        })
      } else {
        this.$emit('input', {
          ...this.value,
          instanceNoClass: n
        })
      }
    },
    'form.field' (n) {
      // 监听扩展属性变化并更新
      this.lf.setProperties(this.nodeId, {
        field: n
      })
    },
    'form.width' (n) {
      // 宽度
      this.lf.setProperties(this.nodeId, {
        width: !n || Number.isNaN(n) ? 120 : n
      })
      const nodeModel = this.lf.getNodeModelById(this.nodeId)
      if (nodeModel) {
        nodeModel.width = !n || Number.isNaN(n) ? 120 : n
      }
    },
    'form.height' (n) {
      // 高度
      this.lf.setProperties(this.nodeId, {
        height: !n || Number.isNaN(n) ? 80 : n
      })
      const nodeModel = this.lf.getNodeModelById(this.nodeId)
      if (nodeModel) {
        nodeModel.height = !n || Number.isNaN(n) ? 80 : n
      }
    },
    'form.version' (n) {
      // 监听方法名属性变化并更新
      this.lf.setProperties(this.nodeId, {
        version: n
      })
    },
    'form.actionBtns' (n) {
      this.lf.setProperties(this.nodeId, {
        actionBtns: n
      })
    },
    form: {
      handler (newVal) {
        if (newVal && this.extendPropertyKeys && this.extendPropertyKeys.length) {
          Object.keys(newVal).forEach(key => {
            if (this.extendPropertyKeys.includes(key)) {
              const v = {
                [key]: newVal[key]
              }
              this.lf.setProperties(this.nodeId, v)
            }
          })
        }
      },
      deep: true // 开启深度监听
    }
  },
  methods: {
    show (node) {
      this.node = node
      if (!this.node || !this.node.type) return
      if (['snaker:start', 'snaker:end'].includes(this.node.type)) {
        return
      }
      switch(this.node.type) {
        case 'snaker:task':
          this.activeForm = 'snaker-task'
          break
        case 'snaker:custom':
          this.activeForm = 'snaker-task'
          break
        case 'snaker:transition':
          this.activeForm = 'snaker-transition'
          break
        case 'snaker:decision':
          this.activeForm = 'snaker-decision'
          break
      }
      this.drawer = true
    },
    handleClose () {
      this.drawer = false
    }
  }
}
</script>

<style scoped>
>>> .el-drawer__body {
    overflow-y: scroll;
  }
>>> .el-drawer__container ::-webkit-scrollbar {
    display: none;
}
::v-deep .el-drawer__header {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
}
</style>
